import { Validators, AbstractControl } from '@angular/forms';
import { patternDocumentType } from './util';

export const ValidatorsByDocumentType = (DOCUMENT_TYPES: string, input: AbstractControl) => {
  const pattern = patternDocumentType(DOCUMENT_TYPES);
  input.setValidators([Validators.pattern(pattern)]);
  input.updateValueAndValidity();
};
